const sanitize = require('sanitize-filename');

export const sanitizeFilename = (fileName: string) => {
  const unSafeCharacterReg = /[{}\^%`[\]#|&$@=;+,~]/g;
  const replacement = '-';
  return sanitize(fileName, { replacement }).replace(unSafeCharacterReg, replacement);
};
